import React, { Component } from "react";
import { MDBDataTable } from "mdbreact";
import {
  Card,
  CardBody,
  Col,
  Row,
  Button,
  Container,
  Badge,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import {
  getTransportDrivers,
  createTransportDriver,
  updateTransportDriver,
  deleteTransportDriver,
} from "../../Endpoint/Admin/index";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { ToastContainer, toast } from "react-toastify";
import { Link } from "react-router-dom";
import ConfirmModal from "../../components/Common/ConfirmModal";

class TransportDrivers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      drivers: [],
      isLoaded: false,
      showModal: false,
      isEditing: false,
      currentDriver: {
        name: "",
        mobile: "",
        email: "",
        vehicleType: "sedan",
        vehicleNumber: "",
        vehicleModel: "",
        notes: "",
        isActive: true,
      },
      // Delete modal states
      showDeleteModal: false,
      selectedDriverId: null,
      deleteLoading: false,
      breadcrumbItems: [
        { title: "Dashboard", link: "/dashboard" },
        { title: "Transport", link: "/transport/requests" },
        { title: "Drivers", link: "#" },
      ],
      tableData: {
        columns: [
          { label: "", field: "searchField", sort: "disabled", width: 0, attributes: { style: { display: "none" } } },
          { label: "Name", field: "name", sort: "asc", width: 150 },
          { label: "Mobile", field: "mobile", sort: "asc", width: 120 },
          { label: "Vehicle", field: "vehicle", sort: "asc", width: 150 },
          { label: "Trips", field: "trips", sort: "asc", width: 80 },
          { label: "Rating", field: "rating", sort: "asc", width: 100 },
          { label: "Status", field: "status", sort: "asc", width: 80 },
          { label: "Actions", field: "actions", sort: "disabled", width: 120 },
        ],
        rows: [],
      },
    };
  }

  componentDidMount() {
    this.loadDrivers();
  }

  loadDrivers = () => {
    getTransportDrivers()
      .then((result) => {
        if (result && result.status === 200) {
          const rows = result.data.map((driver) => this.formatDriverRow(driver));
          this.setState({
            drivers: result.data,
            isLoaded: true,
            tableData: { ...this.state.tableData, rows },
          });
        } else {
          toast.error(result?.message || "Failed to load drivers");
        }
      })
      .catch(() => toast.error("Error loading drivers"));
  };

  formatDriverRow = (driver) => {
    const vehicleTypes = {
      sedan: "Sedan",
      suv: "SUV",
      van: "Van",
      bus: "Bus",
      other: "Other",
    };

    // Create searchField for MDBDataTable search to work properly
    const searchField = [
      driver.name,
      driver.mobile,
      driver.email || "",
      vehicleTypes[driver.vehicleType] || driver.vehicleType,
      driver.vehicleNumber || "",
      driver.isActive ? "Active" : "Inactive",
    ].join(" ").toLowerCase();

    return {
      searchField, // Hidden field for search
      name: (
        <div>
          <strong>{driver.name}</strong>
          {driver.email && <small className="d-block text-muted">{driver.email}</small>}
        </div>
      ),
      mobile: driver.mobile,
      vehicle: (
        <div>
          <Badge color="light" className="text-capitalize">
            {vehicleTypes[driver.vehicleType] || driver.vehicleType}
          </Badge>
          {driver.vehicleNumber && (
            <small className="d-block text-muted mt-1">{driver.vehicleNumber}</small>
          )}
        </div>
      ),
      trips: <span className="font-weight-bold">{driver.totalTrips || 0}</span>,
      rating: (
        <div>
          {driver.totalRatings > 0 ? (
            <>
              <i className="ri-star-fill text-warning mr-1"></i>
              <span>{driver.averageRating?.toFixed(1) || "0.0"}</span>
              <small className="text-muted ml-1">({driver.totalRatings})</small>
            </>
          ) : (
            <span className="text-muted">No ratings</span>
          )}
        </div>
      ),
      status: (
        <Badge color={driver.isActive ? "success" : "secondary"}>
          {driver.isActive ? "Active" : "Inactive"}
        </Badge>
      ),
      actions: (
        <div className="d-flex">
          <Button
            color="primary"
            size="sm"
            className="mr-1 btn-icon"
            onClick={() => this.handleEdit(driver)}
            title="Edit"
          >
            <i className="ri-edit-line"></i>
          </Button>
          <Button
            color="danger"
            size="sm"
            className="btn-icon"
            onClick={() => this.handleDelete(driver._id)}
            title="Delete"
          >
            <i className="ri-delete-bin-line"></i>
          </Button>
        </div>
      ),
    };
  };

  handleAdd = () => {
    this.setState({
      showModal: true,
      isEditing: false,
      currentDriver: {
        name: "",
        mobile: "",
        email: "",
        vehicleType: "sedan",
        vehicleNumber: "",
        vehicleModel: "",
        notes: "",
        isActive: true,
      },
    });
  };

  handleEdit = (driver) => {
    this.setState({
      showModal: true,
      isEditing: true,
      currentDriver: { ...driver },
    });
  };

  handleSave = () => {
    const { currentDriver, isEditing } = this.state;

    if (!currentDriver.name || !currentDriver.mobile) {
      toast.error("Name and mobile are required");
      return;
    }

    if (isEditing) {
      updateTransportDriver(currentDriver._id, currentDriver)
        .then((response) => {
          if (response && response.status === 200) {
            toast.success("Driver updated successfully");
            this.setState({ showModal: false });
            this.loadDrivers();
          } else {
            toast.error(response?.message || "Failed to update driver");
          }
        })
        .catch(() => toast.error("Error updating driver"));
    } else {
      createTransportDriver(currentDriver)
        .then((response) => {
          // Accept both 200 (existing driver updated) and 201 (new driver created)
          if (response && (response.status === 200 || response.status === 201)) {
            const message = response.isExisting
              ? "Driver updated successfully (existing mobile)"
              : "Driver created successfully";
            toast.success(message);
            this.setState({ showModal: false });
            this.loadDrivers();
          } else {
            toast.error(response?.message || "Failed to create driver");
          }
        })
        .catch(() => toast.error("Error creating driver"));
    }
  };

  // Delete modal toggle
  toggleDeleteModal = () => this.setState({ showDeleteModal: !this.state.showDeleteModal });

  handleDelete = (id) => {
    this.setState({ selectedDriverId: id, showDeleteModal: true });
  };

  confirmDelete = () => {
    const { selectedDriverId } = this.state;
    this.setState({ deleteLoading: true });
    deleteTransportDriver(selectedDriverId)
      .then((response) => {
        if (response && response.status === 200) {
          toast.success("Driver deleted");
          this.loadDrivers();
        } else {
          toast.error(response?.message || "Failed to delete driver");
        }
      })
      .catch(() => toast.error("Error deleting driver"))
      .finally(() => {
        this.setState({ deleteLoading: false, showDeleteModal: false, selectedDriverId: null });
      });
  };

  updateField = (field, value) => {
    this.setState({
      currentDriver: { ...this.state.currentDriver, [field]: value },
    });
  };

  render() {
    const { showModal, isEditing, currentDriver } = this.state;

    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <Breadcrumbs title="Transport Drivers" breadcrumbItems={this.state.breadcrumbItems} />

            <Row>
              <Col xs={12}>
                <Card>
                  <CardBody>
                    <div className="d-flex justify-content-between align-items-center mb-4">
                      <h4 className="card-title mb-0">
                        <i className="ri-user-2-line mr-2"></i>
                        Driver Management
                      </h4>
                      <div>
                        <Link to="/transport/requests" className="mr-2">
                          <Button color="secondary" outline>
                            <i className="ri-arrow-left-line mr-1"></i> Back
                          </Button>
                        </Link>
                        <Button color="primary" onClick={this.handleAdd}>
                          <i className="ri-add-line mr-1"></i> Add Driver
                        </Button>
                      </div>
                    </div>

                    <MDBDataTable
                      responsive
                      bordered
                      striped
                      hover
                      noBottomColumns
                      data={this.state.tableData}
                      entriesOptions={[10, 25, 50]}
                      entries={10}
                      pagesAmount={4}
                      className="driver-table"
                    />
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>

        {/* Add/Edit Modal */}
        <Modal isOpen={showModal} toggle={() => this.setState({ showModal: false })} size="lg">
          <ModalHeader toggle={() => this.setState({ showModal: false })}>
            {isEditing ? "Edit Driver" : "Add New Driver"}
          </ModalHeader>
          <ModalBody>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label>Driver Name *</Label>
                  <Input
                    type="text"
                    value={currentDriver.name}
                    onChange={(e) => this.updateField("name", e.target.value)}
                    placeholder="Enter driver name"
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label>Mobile Number *</Label>
                  <Input
                    type="text"
                    value={currentDriver.mobile}
                    onChange={(e) => this.updateField("mobile", e.target.value)}
                    placeholder="Enter mobile number"
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label>Email (Optional)</Label>
                  <Input
                    type="email"
                    value={currentDriver.email}
                    onChange={(e) => this.updateField("email", e.target.value)}
                    placeholder="Enter email address"
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label>Vehicle Type</Label>
                  <Input
                    type="select"
                    value={currentDriver.vehicleType}
                    onChange={(e) => this.updateField("vehicleType", e.target.value)}
                  >
                    <option value="sedan">Sedan</option>
                    <option value="suv">SUV</option>
                    <option value="van">Van</option>
                    <option value="bus">Bus</option>
                    <option value="other">Other</option>
                  </Input>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label>Vehicle Number</Label>
                  <Input
                    type="text"
                    value={currentDriver.vehicleNumber}
                    onChange={(e) => this.updateField("vehicleNumber", e.target.value)}
                    placeholder="e.g., ABC-1234"
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label>Vehicle Model</Label>
                  <Input
                    type="text"
                    value={currentDriver.vehicleModel}
                    onChange={(e) => this.updateField("vehicleModel", e.target.value)}
                    placeholder="e.g., Toyota Camry"
                  />
                </FormGroup>
              </Col>
              <Col xs={12}>
                <FormGroup>
                  <Label>Notes</Label>
                  <Input
                    type="textarea"
                    rows={2}
                    value={currentDriver.notes}
                    onChange={(e) => this.updateField("notes", e.target.value)}
                    placeholder="Any additional notes about the driver"
                  />
                </FormGroup>
              </Col>
              <Col xs={12}>
                <FormGroup check>
                  <Label check>
                    <Input
                      type="checkbox"
                      checked={currentDriver.isActive}
                      onChange={(e) => this.updateField("isActive", e.target.checked)}
                    />
                    {" "}Driver is Active
                  </Label>
                </FormGroup>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={() => this.setState({ showModal: false })}>
              Cancel
            </Button>
            <Button color="primary" onClick={this.handleSave}>
              {isEditing ? "Update Driver" : "Add Driver"}
            </Button>
          </ModalFooter>
        </Modal>

        {/* Delete Confirmation Modal */}
        <ConfirmModal
          isOpen={this.state.showDeleteModal}
          toggle={this.toggleDeleteModal}
          onConfirm={this.confirmDelete}
          title="Delete Driver"
          message="Are you sure you want to delete this driver? This action cannot be undone."
          confirmText="Delete"
          confirmColor="danger"
          icon="ri-delete-bin-line"
          loading={this.state.deleteLoading}
        />

        <ToastContainer />
      </React.Fragment>
    );
  }
}

export default TransportDrivers;
